const FilteredCardForm = () => {
  return (
    <div className="self-stretch flex flex-col items-center justify-start gap-[32px] text-left text-8xl text-dark font-footnote">
      <div className="w-[1169.75px] flex flex-col items-center justify-center">
        <div className="flex flex-row items-center justify-center">
          <div className="flex flex-row p-2.5 items-center justify-center">
            <b className="relative">3</b>
          </div>
          <div className="relative font-medium font-cormorant-garamond">
            Search Results for
          </div>
        </div>
        <b className="relative">Texture sensitive tshirts</b>
      </div>
      <div className="w-[413px] flex flex-row items-center justify-start gap-[16px] text-base sm:pl-4 sm:pr-4 sm:box-border">
        <div className="flex-1 rounded-21xl bg-gray-300 flex flex-row p-4 items-center justify-start gap-[10px] border-[1px] border-solid border-darkslategray-200">
          <div className="flex-1 relative">Things to do</div>
          <img
            className="relative rounded-sm w-4 h-[12.39px]"
            alt=""
            src="/vector-41.svg"
          />
        </div>
        <div className="relative text-8xl font-medium font-cormorant-garamond">
          {" "}
          in
        </div>
        <div className="flex-1 rounded-21xl bg-gray-300 flex flex-row p-4 items-center justify-start gap-[10px] border-[1px] border-solid border-darkslategray-200">
          <div className="flex-1 relative">New York City</div>
          <img
            className="relative rounded-sm w-4 h-[12.39px]"
            alt=""
            src="/vector-411.svg"
          />
        </div>
      </div>
    </div>
  );
};

export default FilteredCardForm;
